import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { WidgetComponent } from '../widget/widget.component';
import { TableComponent } from '../table.component';
import { TableElement } from '../table.element';
import { TableColumn } from '../table.column';

@Component({
  selector: 'app-table-widget-severity',
  templateUrl: './severity.component.html',
  styleUrls: ['./severity.component.css']
})
export class SeverityComponent extends WidgetComponent implements OnInit {

  _severity: string;
  @Input() set severity(_severity: string) {
  console.log("!!!!!!"+_severity);
    this._severity = 'severity ' + _severity;
  }
  get severity(): string {
    return this._severity;
  }

  // tslint:disable-next-line: deprecation
  constructor(ngEl: ElementRef, renderer: Renderer2) {
    super(ngEl, renderer);
  }

  ngOnInit() {
  }

  public setContent(table: TableComponent, tableElement: TableElement, tableColumn: TableColumn): void {
    super.setContent(table, tableElement, tableColumn);

    this.severity = this.getContent();
  }
}
